import EmptyMagnetActivity from "assets/Images/EmptyMagnetActivty.png";
import NoMementos from "assets/Images/NoMementos.png";
import PollEmpty from "assets/Images/PollEmpty.png";
import clsx from "clsx";

export function MementoEmptyStates({ isDark = false }: { isDark?: boolean }) {
  return (
    <div className="my-8 grid h-full place-items-center font-sora text-xxs font-450 opacity-60 lg:mt-4 lg:text-sm">
      <div className="flex flex-col items-center space-y-3">
        <img src={NoMementos} alt="no_mementos" className={clsx("aspect-1 w-1/4 opacity-70", isDark ? "" : "invert")} />
        <p className={clsx("text-center", isDark ? "text-neutral-700" : "text-neutral-100")}>
          The first Magnet benefit is yet to be dropped!
        </p>
      </div>
    </div>
  );
}

export function ActivityEmptyStates({ isDark = false }: { isDark?: boolean }) {
  return (
    <div className="mt-4 grid h-full place-items-center font-sora font-450 opacity-60">
      <div className="flex flex-col items-center space-y-3">
        <img
          src={EmptyMagnetActivity}
          alt="no_activity_yet"
          className={clsx("aspect-1 w-1/4 opacity-70", isDark ? "" : "invert")}
        />
        <p className={clsx("text-center", isDark ? "text-neutral-700" : "text-neutral-100")}>
          This Magnet is yet to start off.
          <br /> Keep an eye out!
        </p>
      </div>
    </div>
  );
}
export function PollEmptyState({ isDark = false }: { isDark?: boolean }) {
  return (
    <div className="my-16 grid h-full place-items-center font-sora font-450 opacity-60 xl:mt-4">
      <div className="flex flex-col items-center space-y-3">
        <img src={PollEmpty} alt="no_poll" className={clsx("aspect-1 w-1/4 opacity-70", isDark ? "" : "invert")} />
        <p className={clsx("text-center", isDark ? "text-neutral-700" : "text-neutral-100")}>
          You have no influence opportunities in this Magnet program for now
        </p>
      </div>
    </div>
  );
}
